import React from "react";
import BackgroundGradient from "../../Components/background";

export default function PrivacyPolicy() {
  return (
    <div>
      <BackgroundGradient color1="#fff" color2="#fff">
        <div className="w-100 container text-center pt-3">
          <p className="h2">
            POLÍTICA DE TRATAMIENTO DE DATOS DE ASEGURAR LTDA
          </p>
          <p className="h3">INTRODUCCIÓN</p>
          <p className="p">
            La Constitución Política de Colombia estableció en el artículo 15 el
            derecho de protección de datos personales como el derecho de toda
            persona para conocer, actualizar, rectificar y/o cancelar la
            información y datos personales que de ella se hayan recolectado y/o
            se traten en bases de datos públicas o privadas.
          </p>
          <p className="p">
            Mediante la Ley 1581 del 17 de octubre de 2012, el Congreso de la
            República reglamentó el ya mencionado derecho al establecer las
            Disposiciones Generales para la Protección de Datos Personales en
            Colombia, igualmente reglamentada por los Decretos 1377 de 2013 y
            886 de 2014 (hoy incorporados en el Decreto único 1074 de 2015),
            entre otros.
          </p>
          <p className="p">
            En cumplimiento de las anteriores disposiciones ASEGURAR LTDA.,
            consciente de la responsabilidad que les asiste en materia de
            Tratamiento de Datos Personales de los titulares, garantiza el
            derecho constitucional que tienen todas las personas a conocer,
            actualizar, rectificar, suprimir y revocar la autorización respecto
            a las informaciones que hayan recogido sobre ellas en las bases de
            datos que la Sociedad, ha recopilado para las finalidades previstas
            en la Ley y en las autorizaciones respectivas, las cuales han sido
            tratadas conforme a lo establecido por el régimen nacional de
            protección de datos personales.
          </p>
          <p className="p">
            Para tales efectos ASEGURAR LTDA. ha elaborado la presente POLÍTICA
            PARA EL TRATAMIENTO DE DATOS PERSONALES, cuya aplicación es de
            carácter obligatorio para todos los suscriptores, proveedores,
            contratistas, trabajadores y demás particulares vinculados a la
            empresa, que hagan tratamiento de los datos personales registrados
            en las bases de datos de la Sociedad, con el fin de proporcionar los
            lineamientos necesarios para el cumplimiento de las obligaciones
            legales en materia de protección de datos personales.
          </p>
          <p className="p">
            ASEGURAR LTDA. se permite informar a todos los interesados, que los
            datos personales que obtenga en virtud de las operaciones que se
            soliciten o celebren con la Entidad, serán tratados conforme a los
            principios y deberes definidos en la ley 1581 de 2012 y demás normas
            que traten y regulen esta materia. Para todos los fines pertinentes,
            el domicilio de ASEGURAR LTDA. será en la CALLE 19 # 27- 41 OFICINA
            202 PISO 2 EDIFICIO MERLOPA – Pasto – Nariño, teléfonos 3155870498-
            6023802851 y correo electrónico asegurar.limitada@gmail.com y página
            web www.asegurar.com.co
          </p>
          <p className="h3">OBJETO.</p>
          <p className="p">
            La presente Política tiene como objeto dar la información necesaria
            y suficiente a los diferentes grupos de interés, así como establecer
            los lineamientos que garanticen la protección de los datos
            personales que son objeto de tratamiento de datos personales a
            través de los vínculos de ASEGURAR LTDA., para de esta forma, dar
            cumplimiento de la ley, políticas y procedimientos de atención de
            derechos de los titulares, criterios de recolección, almacenamiento,
            uso, circulación y supresión que se dará a los datos personales.
          </p>
          <p className="h3">DESTINATARIOS.</p>
          <p className="p">
            Esta política se aplicará a todas las bases de datos tanto físicas
            como digitales, que contengan datos personales y que sean objeto de
            Tratamiento por parte de ASEGURAR LTDA., considerada como
            responsable. Igualmente, en aquellos casos en que operen como
            encargadas del tratamiento de datos personales.
          </p>
          <p className="p">
            La política está dirigida a que QUIENES TENGAN ALGÚN TIPO DE
            VINCULACIÓN CON LA EMPRESA, tengan a su disposición la información
            necesaria y suficiente sobre los diferentes tratamientos y fines
            sobre los que serán objeto sus datos, así como los derechos que
            ellos, como titulares de datos personales, pueden ejercer frente a
            ASEGURAR LTDA. cuando esta tenga el rol de responsable del
            tratamiento de sus datos personales.
          </p>
          <p className="p">
            Esta política es de obligatorio conocimiento y cumplimiento por
            todos los contratistas, trabajadores y demás particulares vinculados
            a la administración de bases de datos personales de ASEGURAR LTDA.
          </p>
          <p className="h3">ALCANCE.</p>
          <p className="p">
            Dar un trámite expedito y legal a las diferentes solicitudes y
            reclamaciones hechas por los Titulares de la Información, así como
            por sus causahabientes u otra persona que cuente con la debida
            autorización.
          </p>
          <p className="p">
            Dar cumplimiento a las exigencias de la normatividad vigente en
            materia de Protección de Datos Personales.
          </p>
          <p className="p">
            Brindar la debida protección a los intereses y necesidades de los
            titulares de la Información personal tratada por ASEGURAR LTDA.
          </p>
          <p className="h3">GLOSARIO</p>
          <p className="p">
            En el desarrollo, interpretación y aplicación del artículo tercero
            de la ley 1581 de 2012 y demás normatividad vigente, se aplicarán,
            de manera armónica e integral, las siguientes definiciones:
          </p>
          <p className="p">
            a)<strong> Autorización:</strong> Consentimiento previo, expreso e
            informado del Titular para llevar a cabo el Tratamiento de datos
            personales;
          </p>
          <p className="p">
            b)<strong> Base de Datos:</strong> Conjunto organizado de datos
            personales que sea objeto de Tratamiento;
          </p>
          <p className="p">
            c)<strong> Dato personal:</strong> Cualquier información vinculada o
            que pueda asociarse a una o varias personas naturales determinadas o
            determinables;
          </p>
          <p className="p">
            d)<strong> Encargado del Tratamiento:</strong> Persona natural o
            jurídica, pública o privada, que por sí misma o en asocio con otros,
            realice el Tratamiento de datos personales por cuenta del
            Responsable del Tratamiento; ASEGURAR LTDA. actúa como encargado del
            tratamiento de datos personales en los casos, en los que por sí
            misma o en asocio con otros, realice el tratamiento de datos
            personales por cuenta de un responsable del tratamiento.
          </p>
          <p className="p">
            e)<strong> Responsable del Tratamiento:</strong> Persona natural o
            jurídica, pública o privada, que por sí misma o en asocio con otros,
            decida sobre la base de datos y/o el Tratamiento de los datos;
            ASEGURAR LTDA. actúa como responsable del tratamiento de datos
            personales frente a todos los datos personales que los terceros le
            han autorizado a tratar.
          </p>

          <p className="p">
            f)<strong> Titular:</strong> Persona natural cuyos datos personales
            sean objeto de Tratamiento;
          </p>

          <p className="p">
            g)<strong> Tratamiento:</strong> Cualquier operación o conjunto de
            operaciones sobre datos personales, tales como la recolección,
            almacenamiento, uso, circulación o supresión.
          </p>

          <p className="p">
            h)<strong> CIRCULACIÓN RESTRINGIDA:</strong> Los datos personales
            sólo serán tratados por aquel personal de ASEGURAR LTDA. o quienes
            dentro de sus funciones tengan a cargo la realización de tales
            actividades. No podrán entregarse Datos Personales a quienes no
            cuenten con autorización o no hayan sido habilitados para tal
            efecto.
          </p>

          <p className="p">
            i)<strong> DATO PERSONAL:</strong> Cualquier información vinculada o
            que pueda asociarse a una o a varias personas naturales determinadas
            o determinables. Debe entonces entenderse el “dato personal” como
            una información relacionada con una persona natural (persona
            individualmente considerada).
          </p>

          <p className="p">
            j)<strong> DATO PÚBLICO:</strong> Es el dato que no sea semiprivado,
            privado o sensible. Son considerados datos públicos, entre otros,
            los datos relativos al estado civil de las personas, a su profesión
            u oficio y a su calidad de comerciante o de servidor público. Por su
            naturaleza, los datos públicos pueden estar contenidos, entre otros,
            en registros públicos, documentos públicos, gacetas y boletines
            oficiales y sentencias judiciales debidamente ejecutoriadas que no
            estén sometidas a reserva.
          </p>

          <p className="p">
            k)<strong> DATO SEMIPRIVADO:</strong> Es aquella información que no
            es de naturaleza íntima, reservada ni pública y cuyo conocimiento o
            divulgación puede interesar no sólo a su titular sino a cierto
            sector o grupo de personas o a la sociedad en general, como es el
            caso de los datos financieros, crediticios o actividades comerciales
          </p>

          <p className="p">
            l)<strong> DATO SENSIBLE:</strong> Aquel dato que afecta la
            intimidad del titular o cuyo uso indebido puede generar su
            discriminación, tales como aquellos que revelen el origen racial o
            étnico, la orientación política, las convicciones religiosas o
            filosóficas, la pertenencia a sindicatos, organizaciones sociales,
            de derechos humanos o que promueva intereses de cualquier partido
            político o que garanticen los derechos y garantías de partidos
            políticos de oposición así como los datos relativos a la salud, a la
            vida sexual y los datos biométricos.
          </p>

          <p className="p">
            m)<strong> INFORMACIÓN DIGITAL:</strong> Toda aquella información
            que es almacenada o transmitida por medios electrónicos y digitales
            como el correo electrónico u otros sistemas de información.
          </p>
          <p className="h3">PRINCIPIOS RECTORES.</p>
          <p className="p">
            En el desarrollo, interpretación y aplicación de la ley,
            regulaciones, y normatividad vigente, se aplicarán, de manera
            armónica e integral, los principios contemplados en el artículo
            cuarto de la Ley 1581 de 2012.
          </p>
          <p className="h2">CATEGORIAS ESPECIALES DE DATOS.</p>
          <p className="h3">DATOS SENSIBLES.</p>
          <p className="p">
            Se entiende por datos sensibles aquellos que afectan la intimidad
            del Titular o cuyo uso indebido puede generar su discriminación,
            tales como aquellos que revelen el origen racial o étnico, la
            orientación política, las convicciones religiosas o filosóficas, la
            pertenencia a sindicatos, organizaciones sociales, de derechos
            humanos o que promueva intereses de cualquier partido político o que
            garanticen los derechos y garantías de partidos políticos de
            oposición así como los datos relativos a la salud, a la vida sexual
            y los datos biométricos.
          </p>
          <p className="h3">TRATAMIENTO DE DATOS SENSIBLES.</p>
          <p className="p">
            Se prohíbe el Tratamiento de datos sensibles, excepto cuando:
          </p>
          <p className="p">
            a) El Titular haya dado su autorización explícita a dicho
            Tratamiento, salvo en los casos que por ley no sea requerido el
            otorgamiento de dicha autorización.
          </p>
          <p className="p">
            b) El Tratamiento sea necesario para salvaguardar el interés vital
            del Titular y este se encuentre física o jurídicamente incapacitado.
            En estos eventos, los representantes legales deberán otorgar su
            autorización.
          </p>
          <p className="p">
            c) El Tratamiento se refiera a datos que sean necesarios para el
            reconocimiento, ejercicio o defensa de un derecho en un proceso
            judicial.
          </p>
          <p className="p">
            d) El Tratamiento tenga una finalidad histórica, estadística o
            científica. En este evento deberán adoptarse las medidas conducentes
            a la supresión de identidad de los Titulares.
          </p>
          <p className="h2">
            AUTORIZACIÓN ESPECIAL DE DATOS PERSONALES SENSIBLES.
          </p>
          <p className="p">
            ASEGURAR LTDA. informará a través de los diversos medios de
            obtención de la autorización a todos sus titulares, que en virtud de
            la ley 1581 del 2012 y normas reglamentarias estos no están
            obligados a otorgar la autorización para el tratamiento de datos
            sensibles.
          </p>
          <p className="p">
            En caso de tratamiento de datos relativos a la salud ASEGURAR LTDA.,
            implementará las medidas necesarias para proteger la
            confidencialidad de la información. Los datos sensibles biométricos
            tratados tienen como finalidad la identificación de las personas, la
            seguridad, el cumplimiento de obligaciones legales y la adecuada
            prestación de los productos.
          </p>
          <p className="h2">DERECHOS DE LOS NIÑOS, NIÑAS Y ADOLESCENTES</p>
          <p className="p">
            El tratamiento de datos personales de niños, niñas y adolescentes
            está prohibido, excepto cuando se trate de datos de naturaleza
            pública, y cuando dicho tratamiento cumpla con los siguientes
            parámetros y/o requisitos:
          </p>
          <p className="p">
            -Que respondan y respeten el interés superior de los niños, niñas y
            adolescentes.
          </p>
          <p className="p">
            -Que se asegure el respeto de sus derechos fundamentales
          </p>
          <p className="p">
            Cumplidos los anteriores requisitos, el representante legal de los
            niños, niñas o adolescentes otorgará la autorización, previo
            ejercicio del menor de su derecho a ser escuchado, opinión que será
            valorada teniendo en cuenta la madurez, autonomía y capacidad para
            entender el asunto.
          </p>
          <p className="h2">TRATAMIENTOS Y FINALIDADES.</p>
          <p className="p">
            De acuerdo con lo establecido en la Ley 1581 de 2012 y de
            conformidad con las autorizaciones impartidas por los titulares de
            la información, ASEGURAR LTDA. realizará operaciones o conjunto de
            operaciones que incluyen recolección de datos, su almacenamiento,
            uso, circulación y/o supresión.
          </p>
          <p className="p">
            Este Tratamiento de datos se realizará exclusivamente para las
            finalidades autorizadas y previstas en la presente Política y en las
            autorizaciones específicas otorgadas por parte del titular.
          </p>
          <p className="p">
            Por la naturaleza jurídica de la sociedad ASEGURAR LTDA. en todos
            los casos los datos personales podrán ser tratados con la finalidad
            de adelantar procesos de control y seguimiento de los contratos
            pactados con terceros, dichos datos serán tratados de acuerdo con el
            grupo de interés y en proporción a la finalidad o finalidades que
            tenga cada tratamiento, como se describe a continuación:
          </p>
          <p className="h3">USUARIOS/CIUDADANÍA GENERAL.</p>
          <p className="p">
            a) Controlar las solicitudes relacionadas con los servicios
            prestados por la Sociedad. El Tratamiento tenga una finalidad
            histórica, estadística o científica. En este evento deberán
            adoptarse las medidas conducentes a la supresión de identidad de los
            Titulares.
          </p>
          <p className="p">
            b) Remitir las respuestas de las consultas y derechos de petición a
            los peticionarios.
          </p>
          <p className="p">
            c) Adelantar los trámites, servicios y otros procedimientos
            administrativos que sean solicitados a la Sociedad.
          </p>
          <p className="p">
            d) Actualizar bases de bases de datos, Incluyendo los casos en que
            se requiera transmitir o transferir a un tercero, la información
            para la validación, depuración, enriquecimiento y homogenización de
            datos, previo cumplimiento de las exigencias legales.
          </p>
          <p className="p">
            e) Manejo de la información por parte de proveedores y/o
            contratistas para las gestiones relacionadas con trámites y
            servicios definidos en sus respectivos vínculos con la Sociedad y
            siempre que ello sea estrictamente necesario.
          </p>
          <p className="p">
            f) Gestionar la información necesaria para el cumplimiento de las
            obligaciones tributarias, contractuales, comerciales y de registros
            comerciales, corporativos y contables.
          </p>
          <p className="p">
            g) Prestar los servicios de información a través de los diferentes
            medios de contacto.
          </p>
          <p className="p">h) Evaluar la calidad de los servicios prestados.</p>
          <p className="p">
            i) Las demás finalidades que se determinen en procesos de obtención
            de Datos Personales para su tratamiento, y en todo caso de acuerdo
            con la Ley y en el marco de las funciones que lo son atribuibles a
            ASEGURAR LTDA.
          </p>
          <p className="h3">FUNCIONARIOS DE ASEGURAR LTDA.</p>
          <p className="p">
            a) Realizar las actividades necesarias para dar cumplimiento a las
            obligaciones legales en relación con los funcionarios y
            exfuncionarios de la Entidad.
          </p>
          <p className="p">
            b) Controlar el cumplimiento de requisitos relacionados con el
            Sistema General de Seguridad Social.
          </p>
          <p className="p">
            c) En caso de datos biométricos capturados a través de sistemas de
            video vigilancia o grabación su tratamiento tendrá como finalidad la
            identificación, seguridad y la prevención de fraude interno y
            externo.
          </p>
          <p className="p">
            d) Informar y comunicar las generalidades de los eventos
            desarrollados por la Sociedad por los medios y en las formas que se
            consideren convenientes.
          </p>
          <p className="p">
            e) Gestionar la cadena presupuestal de la Entidad: pagos de la
            Entidad, emisión de certificados de ingresos y retenciones (personas
            naturales y jurídicas) y relaciones de pagos.
          </p>
          <p className="p">f) Gestionar el proceso Contable de la Sociedad.</p>
          <p className="h3">
            PROVEEDORES – CONTRATISTAS O CONTRATANTES DE ASEGURAR LTDA.
          </p>
          <p className="p">
            a) Para todos los fines relacionados con el objeto de los procesos
            de selección, contractuales o relacionados con éstos.
          </p>
          <p className="p">
            b) Gestionar la cadena presupuestal de la Entidad: pagos de la
            Entidad, emisión de certificados de ingresos y retenciones (personas
            naturales y jurídicas) y relaciones de pagos
          </p>
          <p className="p">
            c) Realizar todas las actividades necesarias para el cumplimiento de
            las diferentes etapas contractuales en las relaciones con
            proveedores, contratantes y contratistas.
          </p>
          <p className="p">
            d) Mantener un archivo digital que permita contar con la información
            correspondiente a cada contrato.
          </p>
          <p className="p">
            e) Las demás finalidades que se determinen en procesos de obtención
            de Datos Personales para su tratamiento, y en todo caso de acuerdo
            con la Ley y en el marco de las funciones que lo son atribuibles a
            ASEGURAR LTDA.
          </p>
          <p className="h2">TRANSFERENCIA Y TRANSMISIÓN DE DATOS PERSONALES.</p>
          <p className="p">
            ASEGURAR LTDA. podrá transferir y transmitir los datos personales a
            terceros con quienes tenga relación operativa que le provean de
            servicios necesarios para su debida operación, o de conformidad con
            las funciones establecidas a su cargo en las leyes. En dichos
            supuestos, se adoptarán las medidas necesarias para que las personas
            que tengan acceso a sus datos personales cumplan con la presente
            Política y con los principios de protección de datos personales y
            obligaciones establecidas en la Ley.
          </p>
          <p className="p">
            En todo caso, cuando ASEGURAR LTDA. transmita los datos a uno o
            varios encargados ubicados dentro o fuera del territorio de la
            República de Colombia, establecerá cláusulas contractuales o
            celebrará un contrato de transmisión de datos personales en el que
            indicará:
          </p>
          <p className="p">1. Alcances del tratamiento,</p>
          <p className="p">
            Las actividades que el encargado realizará por cuenta del
            responsable para el tratamiento de los datos personales y,
          </p>
          <p className="p">
            Las obligaciones del Encargado para con el titular y el responsable
            entre ellas; Guardar confidencialidad respecto del tratamiento de
            los datos personales y salvaguardar la seguridad de las bases de
            datos en los que se contengan datos personales.
          </p>
          <p className="p">
            Mediante dicho contrato el Encargado se comprometerá a dar
            aplicación a las obligaciones del responsable bajo la política de
            Tratamiento de la información fijada por este y a realizar el
            Tratamiento de datos de acuerdo con la finalidad que los Titulares
            hayan autorizado y con las leyes aplicables vigentes.
          </p>
          <p className="h2">
            DERECHOS Y CONDICIONES DE LEGALIDAD PARA EL TRATAMIENTO DE DATOS.
          </p>
          <p className="h2">DERECHOS DE LOS TITULARES.</p>
          <p className="p">
            En el Tratamiento de Datos Personales por parte de ASEGURAR LTDA. se
            respetarán en todo momento los derechos de los titulares de Datos
            Personales que son:
          </p>
          <p className="p">
            a) Conocer, actualizar y rectificar los Datos frente a él o los
            Encargados del Tratamiento de datos.
          </p>
          <p className="p">
            b) Solicitar prueba de la autorización otorgada, o cualquier otra
            que suscriba el titular de los Datos Personales para el efecto,
            salvo cuando expresamente se exceptúe como requisito para el
            Tratamiento de datos de conformidad con la ley.
          </p>
          <p className="p">
            c) Ser informado por la Entidad o el Encargado del Tratamiento,
            previa solicitud, respecto del uso que se le ha dado a los datos.
          </p>
          <p className="p">
            d) Revocar la autorización y/o solicitar la supresión del dato
            cuando en el Tratamiento no se respeten los principios, derechos y
            garantías constitucionales y legales. La revocatoria procederá
            siempre y cuando no exista la obligación legal o contractual de
            conservar el dato personal.
          </p>
          <p className="p">
            e) Acceder en forma gratuita a los Datos Personales que hayan sido
            objeto de Tratamiento.
          </p>
          <p className="h2">AUTORIZACIÓN DEL TITULAR</p>
          <p className="p">
            Sin perjuicio de las excepciones previstas en la ley, en el
            Tratamiento se requiere la autorización previa e informada del
            Titular, la cual deberá ser obtenida por cualquier medio que pueda
            ser objeto de consulta posterior. Se entenderá que la autorización
            cumple con estos requisitos cuando se manifieste (i) por escrito,
            (ii) de forma oral o (iii) mediante conductas inequívocas del
            titular que permitan concluir de forma razonable que otorgó la
            autorización, como cuando, por ejemplo, se remite a la Entidad una
            hoja de vida para participar en procesos de selección o cuando se
            ingresa a las instalaciones a sabiendas de la existencia de sistemas
            de video vigilancia.
          </p>
          <p className="h3">CASOS EN QUE NO ES NECESARIA LA AUTORIZACIÓN.</p>
          <p className="p">
            La autorización del Titular no será necesaria cuando se trate de:
          </p>
          <p className="p">
            a) Información requerida por la Entidad, en ejercicio de sus
            funciones legales o por orden judicial.
          </p>
          <p className="p">b) Datos de naturaleza pública.</p>
          <p className="p">c) Casos de urgencia médica o sanitaria.</p>
          <p className="p">
            d) Datos relacionados con el Registro Civil de las Personas.
          </p>
          <p className="p">
            e) Tratamiento de información autorizado por la ley para fines
            históricos, estadísticos o científicos.
          </p>
          <p className="p">
            Quien acceda a los datos personales sin que medie autorización
            previa deberá en todo caso cumplir con las disposiciones contenidas
            en la Ley 1581 de 2012 y demás normas concordantes y vigentes.
          </p>
          <p className="h2">SUMINISTRO DE LA INFORMACIÓN.</p>
          <p className="p">
            La información solicitada por los Titulares de información personal
            será suministrada principalmente por medios electrónicos, o por
            cualquier otro solo si así lo requiere el Titular. La información
            suministrada por ASEGURAR LTDA. será entregada sin barreras técnicas
            que impidan su acceso; su contenido será de fácil lectura, acceso y
            tendrá que corresponder en un todo a aquella que repose en la base
            de datos.
          </p>
          <p className="h3">DEBER DE INFORMAR AL TITULAR.</p>
          <p className="p">
            ASEGURAR LTDA., al momento de solicitar al Titular la autorización,
            deberá informarle de manera clara y expresa lo siguiente:
          </p>
          <p className="p">
            a) El Tratamiento al cual serán sometidos sus datos personales y la
            finalidad del mismo.
          </p>
          <p className="p">
            b) El carácter facultativo de la respuesta a las preguntas que le
            sean hechas, cuando estas versen sobre datos sensibles o sobre los
            datos de las niñas, niños y adolescentes.
          </p>
          <p className="p">c) Los derechos que le asisten como Titular</p>
          <p className="p">
            d) La identificación, dirección física o electrónica y teléfono del
            responsable del Tratamiento.
          </p>
          <p className="p">
            ASEGURAR LTDA. deberá conservar prueba del cumplimiento de lo
            previsto en el presente numeral y, cuando el Titular lo solicite,
            entregarle copia de esta.
          </p>
          <p className="h3">
            PERSONAS A QUIENES SE LES PUEDE SUMINISTRAR LA INFORMACIÓN.
          </p>
          <p className="p">
            La información que reúna las condiciones establecidas en la ley
            podrá ser suministrada a las siguientes personas:
          </p>
          <p className="p">
            a) A los Titulares, sus causahabientes o sus representantes legales
          </p>
          <p className="p">
            b) A las Entidades públicas o administrativas en ejercicio de sus
            funciones legales o por orden judicial.
          </p>
          <p className="p">
            c) A los terceros autorizados por el Titular o por la ley.
          </p>
          <p className="h2">
            DEBERES DE LOS RESPONSABLES Y ENCARGADOS DEL TRATAMIENTO.
          </p>
          <p className="h3">DEBERES DE LOS RESPONSABLES DEL TRATAMIENTO.</p>
          <p className="p">
            ASEGURAR LTDA. como responsable del Tratamiento, deberá cumplir con
            los deberes contemplados en el artículo 17 de la Ley 1581 de 2012 y
            demás normas que regulen dicha materia.
          </p>
          <p className="h3">DEBERES DEL ENCARGADO DEL TRATAMIENTO.</p>
          <p className="p">
            En el caso en el que ASEGURAR LTDA. actúe como encargado del
            tratamiento, deberá cumplir con los deberes contemplados en el
            artículo 18 de la Ley 1581 de 2012 y demás normas que regulen dicha
            materia.
          </p>
          <p className="h2">
            ACCIONES GENERALES PARA LA PROTECCIÓN DE DATOS PERSONALES.
          </p>
          <p className="h3">TRATAMIENTO DE LA INFORMACIÓN.</p>
          <p className="p">
            Todos los miembros de la Sociedad, al realizar las actividades
            propias de su cargo, asumirán las responsabilidades y las
            obligaciones que se tienen en el manejo adecuado de la información
            personal, desde su recolección, almacenamiento, uso, circulación y
            hasta su disposición final.
          </p>
          <p className="h3">USO DE LA INFORMACIÓN.</p>
          <p className="p">
            La información de carácter personal contenida en las bases de datos
            debe ser utilizada y tratada de acuerdo con las finalidades
            descritas en el apartado TRATAMIENTO Y FINALIDADES de la presente
            política.
          </p>
          <p className="p">
            En caso de que ASEGURAR LTDA. identifique nuevos usos diferentes a
            los descritos en la presente política de tratamiento de datos
            personales, deberá informar al área jurídica, quien evaluará y
            gestionará, cuando aplique, su inclusión en la presente política.
          </p>
          <p className="h3">ALMACENAMIENTO DE LA INFORMACIÓN.</p>
          <p className="p">
            El almacenamiento de la información digital y física se realiza en
            medios o ambientes que cuentan con adecuados controles para la
            protección de los datos. Esto involucra controles de seguridad
            física e informática, en instalaciones propias y/o centros de
            cómputo o centros documentales gestionados por ASEGURAR LTDA.
          </p>
          <p className="h3">DESTRUCCIÓN.</p>
          <p className="p">
            La destrucción de medios físicos y electrónicos se realiza a través
            de mecanismos que no permiten su reconstrucción. Se realiza
            únicamente en los casos en que no constituya el desconocimiento de
            norma legal alguna, dejando siempre la respectiva trazabilidad de la
            acción.
          </p>
          <p className="p">
            La destrucción comprende información contenida en poder de terceros
            como en instalaciones propias.
          </p>
          <p className="h2">
            AREA RESPONSABLE DE LA ATENCIÓN A PETICIONES, CONSULTAS Y RECLAMOS.
          </p>
          <p className="p">
            Las peticiones, consultas y reclamos formulados por los titulares de
            Datos Personales bajo Tratamiento de ASEGURAR LTDA. para ejercer sus
            derechos a conocer, actualizar, rectificar y suprimir datos, o
            revocar la autorización deberán ser dirigidas a: la CALLE 19 # 27-41
            OFICINA 202 PISO 2 EDIFICIO MERLOPA - PASTO (NARIÑO), al teléfono
            3155870498 - 6023802851 y/o al correo electrónico
            asegurar.limitada@gmail.com.
          </p>
          <p className="h2">
            PROCEDIMIENTO PARA EL EJERCICIO DEL DERECHO DE HABEAS DATA.
          </p>
          <p className="p">
            En cumplimiento de las normas sobre protección de datos personales,
            ASEGURAR LTDA presenta el procedimiento y requisitos mínimos para el
            ejercicio de sus derechos:
          </p>
          <p className="p">
            Para la radicación y atención de su solicitud le solicitamos
            suministrar la siguiente información: 1.- Nombre completo y
            apellidos 2.- Datos de contacto (Dirección física y/o electrónica y
            teléfonos de contacto),
          </p>
          <p className="p">
            3.- Medios para recibir respuesta a su solicitud, 4.-
            Motivo(s)/hecho(s) que dan lugar al reclamo con una breve
            descripción del derecho que desea ejercer (conocer, actualizar,
            rectificar, solicitar prueba de la autorización otorgada, revocarla,
            suprimir, acceder a la información) 5.-Firma (si aplica) y número de
            identificación.
          </p>
          <p className="p">
            El término máximo previsto por la ley para resolver su reclamación
            es de quince (15) días hábiles, contado a partir del día siguiente a
            la fecha de su recibo. Cuando no fuere posible atender el reclamo
            dentro de dicho término, ASEGURAR LTDA. Informará al interesado los
            motivos de la demora y la fecha en que se atenderá su reclamo, la
            cual en ningún caso podrá superar los ocho (8) días hábiles
            siguientes al vencimiento del primer término
          </p>
          <p className="p">
            Una vez cumplidos los términos señalados por la Ley 1581 de 2012 y
            las demás normas que la reglamenten o complementen, el Titular al
            que se deniegue, total o parcialmente, el ejercicio de los derechos
            de acceso, actualización, rectificación, supresión y revocación,
            podrá poner su caso en conocimiento de la Superintendencia de
            Industria y Comercio – Delegatura para la Protección de Datos
            Personales.
          </p>
          <p className="h2">RECLAMACIONES SIN CUMPLIMIENTO DE REQUISITOS.</p>
          <p className="p">
            En caso de que la reclamación se presente sin el cumplimiento de los
            anteriores requisitos legales, se solicitará al reclamante dentro de
            los cinco (5) días siguientes a la recepción del reclamo, para que
            subsane las fallas y presente la información o documentos faltantes.
          </p>
          <p className="h3">DESISTIMIENTO DEL RECLAMO.</p>
          <p className="p">
            Transcurridos dos (2) meses desde la fecha del requerimiento sin que
            el solicitante presente la información requerida, se entenderá que
            ha desistido del reclamo.
          </p>
          <p className="h2">PERIODO DE VIGENCIA DE LAS BASES DE DATOS.</p>
          <p className="p">
            Las Bases de Datos de ASEGURAR LTDA. tendrán el periodo de vigencia
            que corresponda a la finalidad CONTRACTUAL para el cual se autorizó
            su tratamiento y de las normas especiales que regulen la materia.
          </p>
          <p className="h2">REGISTRO NACIONAL DE BASE DE DATOS.</p>
          <p className="p">
            De conformidad con el artículo 25 de la Ley 1581 y sus decretos
            reglamentarios, en concreto el Decreto 090 de enero 18 de 2018,
            ASEGURAR LTDA. NO está obligada a registrar sus bases de datos junto
            con la presente política de tratamiento de Datos Personales, en el
            Registro Nacional de bases de datos administrado por la
            Superintendencia de Industria y Comercio, toda vez que sus activos
            totales superiores no superan las 100.000 Unidades de Valor
            Tributario (UVT), en caso de hacerlo, procederá dicho registro
            dentro de los DOS (02) meses siguientes.
          </p>
          <p className="h2">MEDIOS DE CONTROL.</p>
          <p className="p">
            La Sociedad realizará procesos de revisión o auditorías en materia
            de protección de datos personales, con una periodicidad mínima de un
            año o de forma extraordinaria ante incidentes graves que afecten a
            la integridad de las bases de datos personales, a través de la
            Oficina de Control Interno o quien haga sus veces, verificando que
            las políticas y procedimientos se han implementado adecuadamente.
          </p>
          <p className="h2">VIGENCIA, DE LA POLÍTICA.</p>
          <p className="p">
            La presente política de tratamiento de datos personales rige a
            partir de su firma.
          </p>
          <p className="p">
            Las bases de datos en las que se registrarán los datos personales
            tendrán una vigencia igual al tiempo en que se mantenga y utilice la
            información para las finalidades descritas en esta política. Una vez
            se cumpla(n) esa(s)
          </p>
          <p className="p">
            finalidad(es) y siempre que no exista un deber legal o contractual
            de conservar su información, sus datos serán eliminados de nuestras
            bases de datos.
          </p>
          <p className="p">
            Cualquier cambio sustancial en las políticas de Tratamiento de datos
            personales, se comunicará de forma oportuna a los titulares de los
            datos a través de los medios habituales de contacto y/o a través del
            sitio web: www.asegurar.com.co
          </p>
          <p className="p">
            Para los titulares que no tengan acceso a medios electrónicos o
            aquellos a los que no sea posible contactar, se comunicará a través
            de avisos abiertos en la sede principal de la empresa.
          </p>
          <hr />
          <p className="h1">
            POLITICA DE TRATAMIENTO DE DATOS PERSONALES APLICACIÓN MOVIL APP
            CELLVI.
          </p>
          <p className="p">
            A través de la aplicación para equipos móviles celulares que
            funcionan bajo los diferentes sistemas operativos disponibles en el
            mercado tecnológico APP CELLVI (Central Especializada de Logística y
            Localización Vehicular Internacional), la sociedad comercial
            ASEGURAR LTDA, identificada con NIT. 814.004.223-7, domiciliada en
            la Ciudad de San Juan de Pasto – Nariño – Colombia, en la calle 19
            No. 27-41, oficina 202, edificio MERLOPA, Barrio Centro; en relación
            con el tratamiento de datos personales de los Usuarios de la
            Plataforma Tecnológica de Monitoreo Vehicular CELLVI, ejecuta las
            siguientes operaciones:
          </p>
          <p className="p">
            a)- Acceso a los datos personales: Los Usuarios de los Servicios de
            Ubicación Vehicular Remota para hacer uso de la aplicación APP
            CELLVI (Central Especializada de Logística y Localización Vehicular
            Internacional), entregan a la oficina del Administrador de la
            Plataforma de Monitoreo, los siguientes datos: Del Propietario:
            Nombres y apellidos, número de cedula de ciudadanía, número de
            teléfono móvil y fijo, dirección de residencia, correo electrónico,
            Datos de Autorizados y Conductor: Nombres y apellidos, número de
            cedula de ciudadanía, número de teléfono móvil y fijo y, los datos
            marginales de su automotor, como: número de placas, modelo, color,
            número de serie, numero de motor.
          </p>
          <p className="p">
            b)- Recopilación de datos personales: los datos personales de los
            Usuarios de los Servicios de Ubicación Vehicular Remota para hacer
            uso de la aplicación APP CELLVI (Central Especializada de Logística
            y Localización Vehicular Internacional), son guardados en una base
            de datos, la cual se encuentra ligada a los servidores donde se
            aloja el software y los servicios de la plataforma, el acceso a la
            base de datos recopilados es a través de una clave de Administrador
            y una clave de Operador de Medios Tecnológicos, tanto el
            administrador de la plataforma, como los Operadores de Medios
            Tecnológicos, poseen sendos acuerdos de confidencialidad con
            implicaciones de tipo disciplinario, laboral y penal, para el manejo
            de información corporativa considerada como confidencial, donde
            están incluidos los datos personales de nuestros clientes y
            usuarios.
          </p>
          <p className="p">
            c)- Utilización de los datos personales: los datos personales de los
            Usuarios de los Servicios de Ubicación Vehicular Remota para hacer
            uso de la aplicación APP CELLVI (Central Especializada de Logística
            y Localización Vehicular Internacional), se emplean para mantener un
            contacto directo con los Usuarios en los temas de orden
            administrativo, técnico, post venta e, información que los clientes
            requieren a través de la Central de Operaciones, acerca de la
            ubicación de sus rodantes, cuando por diferentes circunstancias no
            pueden acceder a sus móviles, en igual sentido esos datos se
            comparten con las agencias de seguridad del Estado, cuando se
            presentan actos de piratería terrestre en los ejes viales de la
            Republica de Colombia y, se requiere realizar coordinaciones con los
            propietarios de los vehículos que son monitoreados por nuestra
            plataforma de telecomunicaciones, previa solicitud oficial de la
            Entidad Estatal.
          </p>
          <p className="p">
            d)- Como se comparten los datos personales: los datos personales de
            los Usuarios de los Servicios de Ubicación Vehicular Remota para
            hacer uso de la aplicación APP CELLVI (Central Especializada de
            Logística y Localización Vehicular Internacional), se comparten con
            las siguientes entidades del sector público y privado, así:
          </p>
          <p className="p">
            Con relación a los Usuarios de los servicios de monitoreo para
            maquinaria agrícola, industrial y de construcción autopropulsada o
            amarilla. Los datos personales de los propietarios de maquinaria
            amarilla y verde, se comparten a través de un servicio web
            especializado entre la Plataforma de ASEGURAR LTDA., y, la
            Plataforma de la Dirección de Telemática de la Policía Nacional de
            Colombia, esos datos incluyen toda la información marginal tanto del
            propietario de la maquinaria, como de la maquina en sí; lo anterior
            debido a las regulaciones que el estado colombiano realiza sobre
            este tipo de bienes para combatir la minería ilegal.
          </p>
          <p className="p">
            En caso de siniestros por acciones de piratería terrestre, los datos
            de los implicados en estos hechos delictivos se comparten con la
            Policía de Carreteras de Colombia, con el Ejército Nacional de
            Colombia y, con el Cuerpo Técnico de Investigaciones CTI de la
            Fiscalía General de la Nacional.
          </p>
          <p className="p">
            En Igual sentido los datos personales se comparten con la Fiscalía
            General de Nación, cuando se cometen actos delictivos con los
            rodantes que poseen los servicios de la Empresa y, son requeridos
            por el Órgano de Investigación.
          </p>
          <p className="p">
            Con el sector privado o empresas generadoras de carga en Colombia se
            han desarrollado servicios web especializados y, con empresas del
            sector para que vigilen las rutas de trazabilidad de los vehículos
            que se han despachado desde esas empresas, en la actualidad tenemos
            servicios web con: Pegaso, Control T, Gran Tierra, DITRANSA, SOS
            Contingencias, Cemex, Blinda Carga y, Corona. Es importante anotar
            que los datos que se comparten con estas generadoras de carga se
            realizan bajo autorización directa de los propietarios de los
            rodantes.
          </p>
          <p className="p">
            e)- Procedimientos seguros de manejo de datos personales y sensibles
            de los usuarios: El personal autorizado para el manejo de los datos
            personales de los Usuarios de los Servicios de Ubicación Vehicular
            Remota que hacen uso de la aplicación APP CELLVI (Central
            Especializada de Logística y Localización Vehicular Internacional),
            como se explicó en acápites anteriores, tienen firmados y vigentes
            los acuerdos de confidencialidad para el manejo, administración y
            tratamiento de datos personales de nuestros clientes y usuarios, con
            implicaciones de tipo disciplinario, laboral y penal, toda vez que
            los datos personales de los clientes están considerados como
            información corporativa y confidencial, de alto valor para nuestra
            Empresa, por lo tanto se les da un tratamiento especial.
          </p>
          <p className="p">
            f)- Política de retención y eliminación de datos del desarrollador:
            Los desarrolladores del software de la aplicación móvil{" "}
            <strong>APP CELLVI </strong> (Central Especializada de Logística y
            Localización Vehicular Internacional), amén de mantener en vigencia
            su acuerdo de confidencialidad para el manejo de información
            corporativa considerada como confidencial, se han establecido{" "}
            <strong>
              “LOS DERECHOS DE PROPIEDAD INTELECTUAL: En el contrato de trabajo
              de los desarrolladores de aplicaciones web y móvil, se entiende
              que la sociedad comercial ASEGURAR LIMITADA, posee toda la
              “propiedad intelectual” sobre la plataforma CELLVI, existente al
              momento de la celebración del contrato, igualmente las nuevas
              implementaciones, o complementación de la plataforma CELLVI. Es
              importante anotar que la plataforma CELLVI, es propiedad de
              ASEGURAR LTDA., así las cosas, la plataforma CELLVI: (Central
              Especializada de Logística y Localización Vehicular Internacional)
              y, su APP MOVIL, son de PROPIEDAD EXCLUSIVA de ASEGURAR LIMITADA,
              en el entendido que sólo podrá utilizarse por LOS CONTRATISTAS, o
              por terceros, previa LICENCIA de autorización expedida por la
              sociedad ASEGURAR LIMITADA. La información inherente al
              CONTRATANTE que los CONTRATISTAS puedan conocer durante el
              desarrollo de los contratos de desarrollo, lo mismo que la
              documentación suministrada, se considera confidencial y no podrá
              ser divulgada ni utilizada por LOS CONTRATISTAS para efectos
              diferentes a los exigidos en sus contratos. El incumplimiento de
              esta obligación hará responsable a los CONTRATISTAS por los
              perjuicios que se causen directa o indirectamente al CONTRATANTE,
              sin que ello impida la iniciación de acciones penales
              correspondientes a los CONTRATISTAS. En consecuencia, LOS
              CONTRATISTAS, reconocen y aceptan que la plataforma CELLVI, es
              propiedad intelectual e industrial EXCLUSIVA de ASEGURAR LIMITADA;
              que este ES EL DESARROLLADOR ORIGINAL, ÚNICO y, PRIMIGENIO
              PROPIETARIO DE LA PLATAFORMA CELLVI, así como de sus futuras
              versiones, desarrollos, adaptaciones, mejoras, anexos, logotipos,
              documentación, entre otros”
            </strong>
            . Por lo anteriormente expuesto el desarrollador de la aplicación
            CELLVI móvil, no retiene datos, por el contrario, los almacena en
            los dispositivos que para tal motivo se han entregado para su manejo
            y administración a la persona especializada en la administración de
            la plataforma en sí; los datos que son susceptibles de eliminación,
            se tratan y se decide en conjunto, de tal manera que los datos
            captados por el desarrollador, solo sean empleados en beneficio de
            los Usuarios de la aplicación.
          </p>
        </div>
        <hr />
      </BackgroundGradient>
    </div>
  );
}
